<template>
  <div class="sessionModal">
    <div class="modal-container" :style="transparentColor">
      <div class="modal-header">
        <div class="modal-header-top flex">
          <div class="modal-title">{{ modal && modal.title ? modal.title : "" }}</div>
          <div class="modal-close" @click="closeModal">
            <IconBase
              iconColor="#111"
              viewBox="0 0 329.26933 329"
              width="100%"
              height="100%"
              strokeWidth="3px"
              ><IconClose />
            </IconBase>
          </div>
        </div>
        <div class="modal-tabs flex" v-if="modal.tabs">
          <div
            v-for="tab in modal.tabs"
            :key="tab.ID"
            class="modal-tab"
            :class="modal.selectedTab.ID === tab.ID ? 'selected-tab' : ''"
            @click="setTab(tab)"
          >
            {{ tab.name }}
          </div>
          <!-- <div v-if="changedQualitySettings" class="reconnect-container">
            <div class="reconnect-button" @click="reconnect">
              {{ reconnecting ? "Reconnecting" : "Save and reconnect" }}
            </div>
            <span class="reconnect-subtext"
              >For quality settings to take effect, you need to reconnect to the
              session with the new settings.</span
            >
          </div> -->
        </div>
      </div>
      <div class="modal-content flex">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from "../../IconBase";
import IconClose from "../../SVG/IconClose";
import { transparentColor } from "../../../pages/RoomPages/Session/SessionHelpers/colors";

export default {
  name: "SessionModal",
  props: {
    modal: Object,
  },
  components: {
    IconBase,
    IconClose,
  },
  methods: {
    closeModal() {
      this.$emit("closeModal");
    },
    setTab(newTab) {
      this.$emit("setTab", newTab);
    },
  },
  computed: {
    transparentColor() {
      return transparentColor();
    },
  },
};
</script>

<style>
@import "../styles/SessionModal.css";
</style>